const defaultOptions = {
  credentials: 'include',
  cache: 'no-cache',
  headers: {
    'Content-Type': 'application/json',
  },
};

const customFetch = (url, options = {}) => (
  fetch(`${process.env.REACT_APP_API}${url}`, { ...defaultOptions, ...options }).then((response) => {
    if (response.ok) {
      return response;
    }
    if (response.status === 401) {
      window.location.replace(process.env.REACT_APP_SITE_URL);
    }

    throw response;
  }).then((response) => (
    response.text()
      .then((text) => {
        try {
          return JSON.parse(text);
        } catch {
          return {};
        }
      })
  ))
);

export default customFetch;

export const simpleFetch = (url, options = {}) => (
  fetch(`${process.env.REACT_APP_API}${url}`, { ...defaultOptions, ...options })
);
